<template>
  <div class="vuestic-logo" style="display: flex; align-items: center">
    <!-- prefer image from public/ (served at /logo.png) -->
    <img
      v-if="srcComputed"
      :src="srcComputed"
      :style="{ height: responsiveHeight + 'px', width: 'auto' }"
      alt="Verde Admin"
    />

    <!-- text to the right of the image -->
    <div v-if="srcComputed" class="vuestic-logo__text" :style="textWrapperStyle">
      <span class="vuestic-logo__verde" :style="verdeStyle">Verde</span>
      <span class="vuestic-logo__admin" :style="adminStyle">Admin</span>
    </div>

    <!-- fallback to SVG (text-based) -->
    <svg
      v-else
      :height="responsiveHeight"
      alt="Verde Admin"
      fill="none"
      viewBox="0 0 1434 171"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="100%" height="100%" fill="none" />
      <text
        x="0"
        y="126"
        :fill="colorsComputed.start"
        font-family="Inter, Arial, sans-serif"
        font-weight="800"
        font-size="500"
      >
        Hello
      </text>
      <text
        x="660"
        y="48"
        :fill="colorsComputed.start"
        font-family="Inter, Arial, sans-serif"
        font-weight="500"
        font-size="42"
      >
        Admin
      </text>
    </svg>
  </div>
</template>

<script lang="ts" setup>
import { computed, ref, onMounted, onUnmounted } from 'vue'
import { useColors } from 'vuestic-ui'

const { getColor } = useColors()

const props = withDefaults(
  defineProps<{
    height?: number
    start?: string
    end?: string
    src?: string
  }>(),

  {
    height: 80,
    start: 'primary',
    end: undefined,
    src: undefined,
  },
)

// 响应式高度：根据屏幕宽度自动调整
const windowWidth = ref(window.innerWidth)

const responsiveHeight = computed(() => {
  // 小屏幕（手机）：使用较小的高度
  if (windowWidth.value < 640) {
    return Math.min(props.height * 0.2, 40) // 缩小50%，最大40px
  }
  // 中等屏幕（平板）：使用中等高度
  else if (windowWidth.value < 1024) {
    return Math.min(props.height * 0.45, 60) // 缩小25%，最大60px
  }
  // 大屏幕：使用原始高度
  return props.height * 0.7
})

const updateWindowWidth = () => {
  windowWidth.value = window.innerWidth
}

onMounted(() => {
  window.addEventListener('resize', updateWindowWidth)
})

onUnmounted(() => {
  window.removeEventListener('resize', updateWindowWidth)
})

const colorsComputed = computed(() => {
  return {
    start: getColor(props.start),
    end: getColor(props.end || props.start),
  }
})

const srcComputed = computed(() => {
  // if props.src is provided, use it; otherwise try default public path
  return props.src || '/logo.png'
})

const textWrapperStyle = computed(() => {
  return {
    display: 'flex',
    flexDirection: 'column' as const,
    marginLeft: '12px',
    lineHeight: '1',
  }
})

const verdeStyle = computed(() => {
  return {
    color: colorsComputed.value.start,
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeight: 800,
    fontSize: `${responsiveHeight.value * 0.325}px`,
  }
})

const adminStyle = computed(() => {
  return {
    color: colorsComputed.value.start,
    fontFamily: 'Inter, Arial, sans-serif',
    fontWeight: 500,
    fontSize: `${responsiveHeight.value * 0.275}px`,
    marginTop: `${responsiveHeight.value * 0.05}px`,
  }
})
</script>
